module.exports = __webpack_public_path__ + "img/card-el-5.1e546802.svg";